<!--
 * @Autor        : sandyWqh
 * @Date         : 2023-01-17 16:17:00
 * @Description  : 
 * @Version      : 1.0
 * @LastEditors  : sandyWqh
 * @LastEditTime : 2023-02-01 09:15:32
-->
<template>
  <div>
    <Head></Head>
    <div class="banner">
      <img src="/static/onlineEnquiry.jpeg" :alt="$t('langs.onlineEnquiry')" />
    </div>
    <Tab />
    <div class="online_form">
      <el-form
        :model="online_data"
        :rules="rules"
        ref="online_data"
        label-width="100px"
        class="online"
      >
        <div class="form_desc">
          <p>
            <span>{{$t("langs.customer")}}</span>
          </p>
          <p>
            <span class="--mb--rich-text">
              {{$t('langs.form_info')}}
              <span class="flag_star">*</span>
              {{$t('langs.form_desc')}}
            </span>
          </p>
        </div>
        <div style="margin-left:10%;">
          <el-form-item :label="$t('langs.form_title.product_name')" prop="product_id" required>
            <el-select
              class="select_width"
              :placeholder="$t('langs.select_txt')"
              @change="getLabel"
              v-model.trim()="online_data.product_id"
            >
              <el-option :label="$t('langs.centerpower')" value="centerpower"></el-option>
              <el-option :label="$t('langs.centerbms')" value="centerbms"></el-option>
              <el-option :label="$t('langs.centermotorcycle')" value="centermotorcycle"></el-option>
              <el-option :label="$t('langs.cloudplatform')" value="cloudplatform"></el-option>
              <el-option :label="$t('langs.communication')" value="communication"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('langs.form_title.contact_user')"
            prop="contact_user"
            required
            class="input_width"
          >
            <el-input v-model.trim()="online_data.contact_user"></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('langs.form_title.mobile_phone')"
            prop="mobile_phone"
            required
            class="input_width"
          >
            <el-input v-model.trim()="online_data.mobile_phone"></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('langs.form_title.email_address')"
            prop="email_address"
            required
            class="input_width"
          >
            <el-input v-model.trim()="online_data.email_address"></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('langs.form_title.company_name')"
            prop="company_name"
            class="input_width"
          >
            <el-input v-model="online_data.company_name" required></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('langs.form_title.country_area')"
            prop="country_area"
            class="input_width"
          >
            <el-input v-model.trim()="online_data.country_area"></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('langs.form_title.detial_desc')"
            prop="detial_desc"
            style="width:80%;"
          >
            <el-input type="textarea" v-model.trim()="online_data.detial_desc" rows="8"></el-input>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary" class="btn_submit" @click="submitForm">{{$t('langs.submit')}}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <Footer />
  </div>
</template>

<script>
import Head from "../components/head/head.vue";
import Footer from "../components/footer/footer.vue";
import Tab from "../components/about/tab.vue";
import axios from "axios";
export default {
  name: "enquiry",
  components: { Head, Footer, Tab },
  data() {
    return {
      online_data: {
        product_id: "",
        product_name: "",
        contact_user: "",
        mobile_phone: "",
        email_address: "",
        company_name: "",
        country_area: "",
        detial_desc: ""
      },
      rules: {
        product_name: [
          {
            required: true,
            message: this.$t("langs.valid_message.product_name"),
            trigger: "change"
          }
        ],
        company_name: [
          {
            required: true,
            message: this.$t("langs.valid_message.company_name"),
            trigger: "blur"
          }
        ],
        contact_user: [
          {
            required: true,
            message: this.$t("langs.valid_message.contact_user"),
            trigger: "blur"
          }
        ],

        mobile_phone: [
          {
            pattern: /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/,
            required: true,
            message: this.$t("langs.valid_message.mobile_phone"),
            trigger: "blur"
          }
        ],
        email_address: [
          {
            required: true,
            type: "email",
            message: this.$t("langs.valid_message.email_address"),
            trigger: "blur"
          }
        ],
        detial_desc: [
          {
            trigger: "blur",
            required: true,
            message: this.$t("langs.valid_message.detial_desc")
          },
          {
            min: 10,
            max: 2000,
            trigger: "blur"
          }
        ]
      },
      options: [
        { value: "centerpower", text: "储能电池箱" },
        { value: "centerbms", text: "智能家储电池板" },
        { value: "centermotorcycle", text: "两轮/三轮车BMS" },
        { value: "cloudplatform", text: "云平台" },
        { value: "communication", text: "WiFi通讯模块" }
      ]
    };
  },
  methods: {
    getLabel(value) {
      let opt = {};
      opt = this.options.find(item => {
        return item.value === value;
      });
      if (opt) {
        this.online_data.product_name = opt.text;
      }
    },
    submitForm() {
      this.$refs["online_data"].validate(valid => {
        if (valid) {
          let data = Object.assign({}, this.online_data);
          data.record_type = 0;
          let vm = this;
          axios
            .post("/api/admin/base/open/consult", data)
            .then(res => {
              vm.$message({
                message: "提交成功",
                type: "success",
                duration: 1000
              });
              vm.resetForm();
            })
            .catch(error => {
              vm.$message({
                message: "操作异常",
                type: "error",
                duration: 1000
              });
            });
        }
      });
    },
    resetForm() {
      this.$refs["online_data"].resetFields();
    }
  }
};
</script>

<style  scoped>
@import "../assets/css/common.css";

.online_form {
  width: 60%;
  margin-top: 20px;
  margin-left: 20%;
  border: 1px solid lightgray;
}
.online {
  padding: 15px;
}
.form_desc {
  padding: 20px;
  margin-left: 20px;
  font-size: 16px;
}
.form_desc > p {
  margin-bottom: 5px;
}
.flag_star {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}
.input_width {
  width: 50%;
}
.select_width {
  width: 42%;
}
.btn_submit {
  margin: 0 40%;
}
</style>


// WEBPACK FOOTER //
// src/view/online_enquiry.vue